import { BACKEND_URL_PREFIX } from "../utils/const";
import { checkAndUpdateToken } from "./auth";
import {
  FACULTY_FETCHED,
  ACADEMIC_YEAR_FETCHED,
  ACADEMIC_PERIOD_FETCH_START,
  ACADEMIC_PERIOD_FETCH_END,
  NETWORK_REQUEST_SENT,
  CATHEDRA_FETCHED,
  GROUP_FETCHED,
  DISCIPLINE_FETCHED,
  CONTROL_FETCHED,
  TEST_RESULT_FETCHED,
  TEST_RESULT_PHOTO_FETCHED,
  RESET_DOCUMENTS,
  CLEAR_TEST_RESULTS,
  COURSES_PR_FETCHED,
} from "./types";
import { arrayBufferToBase64, buildDefaultHeaders } from "./helper";
import { getDefaultYearOrTerm } from "../containers/getDefault";

export const getAcademicPeriod = (yearId) => async (dispatch, getState) => {

  dispatch({ type: ACADEMIC_PERIOD_FETCH_START });

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/year/term/${yearId}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const academicPeriod = await response.json();
    dispatch({ type: ACADEMIC_PERIOD_FETCH_END, academicPeriod });
  }
};

export const getCathedra = (facultyId, val, isJournalAdmin) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const filter = facultyId ? `?idfaculty=${facultyId}` : "";
    
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/cathedra${isJournalAdmin ? "" : "/teacher"
      }${filter}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: CATHEDRA_FETCHED, cathedra: data.items || [], check: val });
    }
  }
};

export const getAcademicYear = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/year/scy`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      console.log(data)
      dispatch({ type: ACADEMIC_YEAR_FETCHED, academicYear: data });
    }
  }
};

export const getFaculty = (val, isJournalAdmin) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/faculty${isJournalAdmin ? "" : "/teacher"}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: FACULTY_FETCHED, faculty: isJournalAdmin ? data.items : data, check: val });
    }
  }
};

export const getGroup = (
  facultyId,
  cathedraId,
  yearId,
  isJournalAdmin
) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group${isJournalAdmin ? "" : "/teacher"
      }/${facultyId}/${cathedraId}/${yearId}/0`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_FETCHED, group: data });
    }
  }
};

export const getJurnalGroup = (cid, term, isJournalAdmin) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group${isJournalAdmin ? "" : "/teacher"}/${cid === "Все" ? 0 : cid
      }/${term || 0}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_FETCHED, group: data });
    }
  }
};

export const getGroupNew = (school_year_id, faculty_id, term_id, cathedra_id,) => async (
  dispatch,
  getState
) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = {}
    faculty_id && faculty_id != 0 && (params.faculty_id = faculty_id)
    cathedra_id && cathedra_id != 0 && (params.cathedra_id = cathedra_id)

    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(!!urlParams ?
      `${BACKEND_URL_PREFIX}/group/${school_year_id}/${term_id}?${urlParams}` :
      `${BACKEND_URL_PREFIX}/group/${school_year_id}/${term_id}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_FETCHED, group: data });
    }
  }
};
export const getGroupProgressReport = (school_year_id, faculty_id, term_id, cathedra_id,) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = {}
    faculty_id && faculty_id != 0 && (params.faculty_id = +faculty_id)
    cathedra_id && cathedra_id != 0 && (params.cathedra_id = +cathedra_id)

    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(`${BACKEND_URL_PREFIX}/group/journal_of_accounting_of_training_sessions/${school_year_id}/${term_id}?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GROUP_FETCHED, group: data });
    }
  }
};
export const getFacultyProgressReport = () => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/journal_of_accounting_of_training_sessions/faculty/teacher`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: FACULTY_FETCHED, faculty: data });
    }
  }
};
export const getCathedraProgressReport = (faculty_id, term_id, cathedra_id,) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/journal_of_accounting_of_training_sessions/cathedra/teacher/f/${faculty_id}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: CATHEDRA_FETCHED, cathedra: data });
    }
  }
};

export const getCoursesProgressReport = (groupId, term_id,) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/course/teacher/${groupId}/${term_id}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: DISCIPLINE_FETCHED, discipline: data });
    }
  }
};



export const getDiscipline = (groupId, periodId, isJournalAdmin) => async (
  dispatch,
  getState
) => {
  if (groupId && periodId) {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/course${isJournalAdmin ? "" : "/teacher"
        }/${groupId}/${periodId}`,
        buildDefaultHeaders(getState)
      );
      dispatch({ type: NETWORK_REQUEST_SENT, response });

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: DISCIPLINE_FETCHED, discipline: data });
      }
    }
  }
};

export const getFormOfControl = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/testtype`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: CONTROL_FETCHED, control: data });
    }
  }
};

export const getTestResultDocs = (jcId, fileName, idx) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const responsePhoto = await fetch(
      `${BACKEND_URL_PREFIX}/testresult/${jcId}/${fileName}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, responsePhoto });

    if (responsePhoto.ok) {
      const buffer = await responsePhoto.arrayBuffer();
      const convertPhoto = arrayBufferToBase64(buffer);
      dispatch({
        type: TEST_RESULT_PHOTO_FETCHED,
        idx,
        testResultPhoto: convertPhoto,
      });
    }
  }
};

export const getTestResult = (
  academicPeriodId,
  disciplineId,
  groupId,
  controlId
) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    if (academicPeriodId && disciplineId && groupId && controlId) {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/testresult/${academicPeriodId}/${disciplineId}/${groupId}/${controlId}`,
        buildDefaultHeaders(getState)
      );

      dispatch({ type: NETWORK_REQUEST_SENT, response });

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: TEST_RESULT_FETCHED, testResult: data });
        dispatch({ type: RESET_DOCUMENTS });
        // eslint-disable-next-line
        data.files !== null &&
          data.files.map(
            async (file, idx) =>
              await dispatch(getTestResultDocs(data.jcid, file.file, idx))
          );
      }
    } else {
      dispatch({ type: CLEAR_TEST_RESULTS });
      dispatch({ type: RESET_DOCUMENTS });
    }
  }
};
